import { DEFAULT_APP_TITLE } from "../../../config";

export const ADMITTED_TITLE = `🚪 Join your session! - ${DEFAULT_APP_TITLE}`;
